const PreApprovedVisitor = {

    // PAGE HEADER
    "pre_approved_visitor": "Pre Approved Visitor",

    // FIELDS
    "premise": "Premise",
    "gate": "Gate",
    "visitor_name": "Visitor Name",
    "mobile_number": "Mobile Number",
    "type": "Type",
    "sub_type": "Sub Type",
    "unit": "Unit",
    "validity": "Validity",
    "visit_time": "Visit Time",
    "people_allowed": "People Allowed",
    "purpose": "Purpose",
    "vehicle_number": "Vehicle Number",
    "search": "Search",

    // TABLE HEADERS
    "table_premise": "PREMISE",
    "table_gate": "GATE",
    "table_visitor": "VISITOR",
    "table_type": "TYPE",
    "table_validity": "VALIDITY",
    "table_vehicle": "VEHICLE",
    "table_purpose": "PURPOSE",
    "table_status": "STATUS",

    // ERROR
    "error_premise": "Select Premise",
    "error_gate": "Select Gate",
    "error_visitor_name": "Enter Visitor Name",
    "error_mobile_number": "Enter Mobile Number",
    "error_invalid_mobile": "Invalid Mobile Number",
    "error_type": "Select Type",
    "error_sub_type": "Select Sub Type",
    "error_unit": "Select Unit",
    "error_validity": "Select Validity",
    "error_visit_time": "Select Visit Time",
    "error_people_allowed": "Enter People Allowed",
    "error_invalid_people_allowed": "Enter Valid People Allowed",
    "error_purpose": "Enter Purpose",
    "error_vehicle_number": "Enter Vehicle Number",

}

export default PreApprovedVisitor;